import React, { FC } from 'react';
import { iconSize } from '../../../../constants/icon.constants';
import { FieldEditFrameComponent } from '../../../@shared/editFrame';
import Icon from '../../../@shared/icon';
import { RichText, Text } from '@sitecore-jss/sitecore-jss-react';
import StyledLink from '../../../@shared/styledLink';
import { TExploreServicesCardContent } from './types/card.types';

const ExploreServicesCardContent: FC<TExploreServicesCardContent> = (props) => {
  const { id, fields, icon, title, subtitle, sitecoreContext, cardHeadingTitleTag, link } = props;
  return (
    <>
      <div className="explore-services-card__icon">
        <FieldEditFrameComponent itemId={id} fields={[fields?.icon]} sitecoreContext={sitecoreContext}>
          <Icon iconField={icon} color={'primary'} size={iconSize.xxlg} />
        </FieldEditFrameComponent>
      </div>
      <div className="explore-services-card__text-wrapper">
        <Text tag={cardHeadingTitleTag} field={title} className="explore-services-card__title" />
        <RichText tag="div" field={subtitle} className="explore-services-card__subtitle rich-text" />
        <div className="explore-services-card__cta">
          {sitecoreContext.pageEditing ? (
            <StyledLink field={link} />
          ) : (
            <span className="link-with-arrow link-with-arrow--text">
              {link?.value?.text}
              <Icon iconName="arrow-chevron-right" color={'primary'} size={iconSize.xlg} extraClassName="link-with-arrow--icon" />
            </span>
          )}
        </div>
      </div>
    </>
  );
};

export default ExploreServicesCardContent;
